import {
    IGetDataGroupCompanyProtocolResponse,
    IGroupCompanyProtocolDto,
} from 'pages/ais/organization-structure-v5/api/types';
import {IGetDataArgs} from 'pages/ais/organization-structure-v5/model/types';
import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

const GROUP_PROTOCOL_ROUTE = '/integration.module/ais3.company.group.proto.info';

const getData = (args?: IGetDataArgs) =>
    performRequest<IGetDataGroupCompanyProtocolResponse>({
        url: GROUP_PROTOCOL_ROUTE,
        method: ERequestType.GET,
        params: args,
    });

const getDataById = (id: number) =>
    performRequest<IGroupCompanyProtocolDto>({url: `${GROUP_PROTOCOL_ROUTE}/${id}`, method: ERequestType.GET});

export const groupCompanyProtocolApi = {getData, getDataById};